var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-main',[_c('Header'),_c('router-view',{key:_vm.$route.fullPath,staticClass:"bodySection"}),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }